<template>
    <div class="layout-header" >
        <div class="logo_content">
            <img class='logo' src="../assets/image/image.png" />
        </div>
        <div class="menus">
            <a-menu class='top-bar-menu' v-model:selectedKeys="current" :items="items" mode="horizontal" theme="dark" @click="topbar_change"></a-menu>
        </div>
        <div class="toolbar_layout">
            <div class="toolbar">
                <div class="notice">
                    <BellOutlined style="color:#fff;width:18px;font-size:18px;" />
                </div>
                <div class="management">
                    <a-dropdown placement="bottomRight"
                    :overlayStyle="{'background':'#0F172A'}" 
                    trigger="['click']">
                        <div class="management-icon" @click.prevent></div>
                        <template #overlay>
                            <a-menu style="background: #0F172A">
                                <a-menu-item key="1" style="color: white;" >
                                    <a href="#/libs">
                                        Compl-Libs
                                    </a>
                                </a-menu-item>
                            </a-menu>
                        </template>
                    </a-dropdown>
                </div>
                <div class="language">
                    
                    <div class="management-icon language-icon" ></div>
                    
                </div>
                <!-- <div class="user_info">
                    <img style="width:24px;height:24px;border-radius:12px;margin-right:8px;" :src="userInfo.avatarUrl" />
                    <span style="max-width:64px;font-size:14px;font-weight:400;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;line-height:22px;">{{ userInfo.name }}</span>
                </div> -->
                <a-dropdown :trigger="['click']" :overlay-style="{background:'#0F172A'}">
                    <div class="user_info" @click.prevent>
                        
                        <a-avatar v-if="userInfo.name != ''" :style="avatar_style" size="small">{{ userInfo.name[0].toUpperCase() }}</a-avatar>
                        <span style="margin-left:8px;max-width:64px;font-size:14px;font-weight:400;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;line-height:22px;">{{ userInfo.name }}</span>
                    </div>
                    <template #overlay>
                        <div class="user-menu"><a-menu style="background: black;">
                            <a-menu-item key="1">
                                <a style="color:#fff;" href="javascript:void(0)" @click="logOut">Sign out</a>
                            </a-menu-item>
                        </a-menu></div>
                    </template>
                </a-dropdown>
            </div>
        </div>
        
    </div>
</template>

<script lang="ts">
import { h, defineComponent, ref , defineEmits} from 'vue';
import { BellOutlined, AppstoreOutlined,GlobalOutlined, ClockCircleOutlined} from '@ant-design/icons-vue';
import { MenuProps } from 'ant-design-vue';
import axios from 'axios';
import { setCache, getCache } from '@/common/storage';
import router from '@/router'
export default defineComponent({
  name: 'TopBar',
  components:{
    BellOutlined,
    AppstoreOutlined
  },

  
  setup(props, { emit }){
    const current = ref<string[]>(["clearance"])
    const isLoading = ref(false)
    
    const items = ref<MenuProps['items']>([
        {
            key: 'dashboard',
            icon: ()=> h(AppstoreOutlined),
            label: 'DashBoard',
            title: 'DashBoard',
            disabled: true
        },
        {
            key: 'clearance',
            icon: () => h(GlobalOutlined),
            label: 'Clearance',
            title: 'Clearance',
        },
        {
            key: 'Fantracking',
            icon: () => h(ClockCircleOutlined),
            label: 'Fantracking',
            title: 'Fantracking',
            disabled : true,
        },

    ])
    interface userInfo {
        name: string,
        avatarUrl: string,
    }
    const userInfo = ref<userInfo>({
        name: '',
        avatarUrl: '',
    })
    let userCacheInfo = getCache('userInfo')
    if (userCacheInfo && userCacheInfo.userName) {
        userInfo.value.name = userCacheInfo.userName
    }
    if(userCacheInfo ) {
        //userInfo.value.avatarUrl = userCacheInfo.avatarUrl
        userInfo.value.avatarUrl = "https://gd-hbimg.huaban.com/dc4b46d78ad5d8f1657dc3b3dd28d7bec4a9b6c418bc9-TFXE1F_fw658webp"
        
    }

    const color_arr : Array<string> = ["#0D99FF", "#FF5C16","#FFAB00","#1EC772",,"#9747FF","#757575"]
    const avatar_style = "background:" + color_arr[Math.floor(Math.random() * color_arr.length)] + ";color: #ffffff";

    const logOut = async()=> {
        console.log('logOut')
       
        let config = {
        method: 'post',
        url: '/api/auth/logout',
        }
        emit('custom-event', true)
        axios(config).then(function (response) {
            emit('custom-event', false)
            // console.log(JSON.stringify(response.data))
            // // 登出成功后需置空userInfo
            setCache('userInfo', '')
            setCache('jwt', '')
            router.push({path: '/login'})
        }).catch(function (error) {
            emit('custom-event', false)
            console.log(error)
        })
        
    }
    const topbar_change = (params : any)=>{
        //console.log('click over', e)
        if( params && params?.key){
            if( params.key === "clearance"){
                router.push({path: "/"})
            }
        }
    }
    return {
        current,
        items: items,
        userInfo,
        logOut,
        isLoading,
        avatar_style,
        topbar_change
    }
    
  }

});
</script>

<style scoped>
.layout-header {
    background-color: #0F172A;
    width: 100%;
    height: 48px;
    display: flex;
}
.logo_content{
    margin-left: 24px;
    width: 94px;
    height: 48px;
    align-content: center;
}
.logo{
    /* top: 10px; */
    width: 94px;
    height: 28px;
}
.menus{
    margin-left: 154px;
    flex:1
}
.top-bar-menu{
    gap:6px;
    height: 28px;
    line-height: 28px;
    margin-top: 10px;
}
.top-bar-menu :deep(.ant-menu-item-selected){
    border-radius: 100px;
    line-height: 28px;
    padding-top: 0px;
    background: #1677ff;
    
}
.top-bar-menu :deep(.ant-menu-item){
    line-height: 28px;
}
.toolbar_layout{
    display: flex;
    justify-content: flex-end; /* 使子元素靠右 */
    margin-block-end: 0px;
    width:275px;
}
.toolbar{
    width: 275px;
    height: 48px;
    display: flex;
}
.notice{
    width: 48px;
    align-content: center;
    text-align: center;
}
.management{
    width: 48px;
    align-content: center;
    text-align: center;
}
.management-icon {
    margin: auto;
    width: 24px;
    height: 24px;
    mask-image: url('../assets/image/expand.svg');
    background-color: #fff;
    mask-repeat: no-repeat;
    -webkit-mask-repeat: no-repeat;
    -moz-mask-repeat: no-repeat;
    mask-size: contain;
    -webkit-mask-size: contain;
    -moz-mask-size: contain;
    mask-position: center;
    -webkit-mask-position: center;
    -moz-mask-position: center;
    cursor: pointer;
}
.language-icon {
    width: 18px;
    height: 18px;
    mask-image: url('../assets/image/lang.svg');
}
.language{
    width: 42px;
    align-content: center;
    text-align: center;
}
.user_info{
    width: 113px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.user-menu ul {
    background-color: #0F172A;
}
.user-menu li a {
    color: #fff;
}
 /* .ant-menu-horizontal > .ant-menu-item-selected {
    border-radius: 100px;
    height: 28px;
    padding: 2px,12px,2px,12px;
    border-radius: 100px;
} */

</style>